// Extend Window interface for runtime env config
declare global {
  interface Window {
    _env_?: {
      REACT_APP_BASE_URL?: string;
    };
  }
}

// Get base URL - use current origin for multi-domain support
const getBaseUrl = (): string => {
  // In browser, use current origin (supports app.valueit.io and valueit.lk)
  if (typeof window !== "undefined" && window.location.origin) {
    // Only use origin if it's not localhost (development)
    if (!window.location.origin.includes("localhost")) {
      return window.location.origin;
    }
  }

  // Fallback: runtime config, then env var, then localhost
  return (
    (typeof window !== "undefined" && window._env_?.REACT_APP_BASE_URL) ||
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:3001"
  );
};

// Use runtime config (window._env_) for production, fallback for development
export const BACKEND_BASE_URL = getBaseUrl();

// Socket URL (same as backend base URL)
export const SOCKET_URL = BACKEND_BASE_URL;
